import type { ConceptDef } from '../types';

export const receptivePictures: ConceptDef = {
  kind: 'tileMatch',
  id: 'receptive-pictures',
  label: 'Receptive Pictures',
  category: 'Receptive',
  description: 'Hear a noun and tap the matching picture.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'apple', answer: '🍎 apple' },
      { say: 'banana', answer: '🍌 banana' },
      { say: 'dog', answer: '🐶 dog' },
      { say: 'cat', answer: '🐱 cat' },
      { say: 'car', answer: '🚗 car' },
      { say: 'tree', answer: '🌳 tree' },
      { say: 'book', answer: '📕 book' },
      { say: 'ball', answer: '⚽ ball' },
    ],
  },
};
